import { useContext } from 'react'
import { ContentContext } from './ContentContext'
import type { SiteContent } from './schema'

/**
 * The site's content. Throws outside a `ContentProvider`, by design —
 * a component rendering stale module-level data would be worse.
 */
export const useContent = (): SiteContent => {
  const context = useContext(ContentContext)
  if (!context) {
    throw new Error('useContent must be used inside a ContentProvider')
  }
  return context.content
}
